import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { submitAuthenticate } from '@/services/login.service';
import type {
  AuthenticateRequest,
  AuthenticateResponse,
} from '@/services/login.types';

type Options = Pick<
  UseMutationOptions<AuthenticateResponse, unknown, AuthenticateRequest>,
  'onSuccess' | 'onError'
>;

const useAuthenticateMutation = (options: Options = {}) =>
  useMutation<AuthenticateResponse, unknown, AuthenticateRequest>({
    mutationFn: (body) => submitAuthenticate(body),
    ...options,
  });

export default useAuthenticateMutation;
